import {
    DEALETGETLISTDSRMASTER_SUCCESS,
    DEALETGETLISTDSRMASTER_FAILED,
    RESET_DEALETGETLISTDSRMASTER,
    LOADING_DEALETGETLISTDSRMASTER,
    NETWORK_ERROR_DEALETGETLISTDSRMASTER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALETGETLISTDSRMASTER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALETGETLISTDSRMASTER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALETGETLISTDSRMASTER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALETGETLISTDSRMASTER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALETGETLISTDSRMASTER:
            return (state = initialState);
        default:
            return state;
    }
};
